export const ExperimentsConsts = {
  CancellationFeesUoU: 'specs.bookings.CancellationFeesUoU',
};
